const slideImages = [
  // {
  //   url: 'assets/img/seletivo_002_2026.png',
  //   caption: '',
  // },
  {
    url: 'assets/img/turma8/foto_oficial_turma_8.png',
    caption: 'Boas-vindas para Turma 8',
  },
  {
    url: 'assets/img/turma7/foto_oficial_turma_7.jpg',
    caption: 'Boas-vindas para Turma 7',
  },
  {
    url: 'assets/img/divulgacao/IMG_3065.png',
    caption: 'Parabéns para 6ª Turma de Web Developers FullStacks 🥳 !',
  },
  {
    url: 'assets/galeria/turma1_ead/turma1_ead.jpeg',
    caption: 'Parabéns para 1ª Turma EaD FullStacks 🥳 ! ',
  },
  // {
  //   url: 'assets/img/divulgacao/t3_final.jpg',
  //   caption: 'Parabéns! Novos Devs FullStack Turma 3 🥳',
  // },
  // {
  //   url: 'assets/img/divulgacao/turma2_cc.jpg',
  //   caption: 'Novos Devs FullStack da 2ª Turma! 🥳',
  // },
  // {
  //   url: 'assets/img/divulgacao/turma1.jpg',
  //   caption: 'Entrega de certificados para 1ª Turma do Projeto WebAcademy',
  // },
];

export default slideImages;
